import { Controller } from "@hotwired/stimulus"

// § 3.14 Tier 2 — per-source "Send for Signature" trigger.
//
// Each CO card / Closeout row / Attachment card carries a small wrapper
// with `data-controller="docusign-send-modal-trigger"` + the source's
// `source_type` / `source_id` / display label. Clicking dispatches a
// `docusign-send-modal:open` window event the page-level modal listens
// for via its own controller. Single modal, many triggers.
export default class extends Controller {
  static values = {
    sourceType: String,
    sourceId: String,
    sourceLabel: String,
    defaultSubject: String,
    defaultBody: String,
    defaultSigners: { type: String, default: "[]" }
  }

  open(event) {
    if (event) event.preventDefault()
    let signers = []
    try {
      signers = JSON.parse(this.defaultSignersValue || "[]")
    } catch (_e) {
      signers = []
    }
    window.dispatchEvent(new CustomEvent("docusign-send-modal:open", {
      detail: {
        sourceType: this.sourceTypeValue,
        sourceId: this.sourceIdValue,
        sourceLabel: this.sourceLabelValue,
        defaultSubject: this.defaultSubjectValue,
        defaultBody: this.defaultBodyValue,
        defaultSigners: signers
      }
    }))
  }
}
